import { Link, Outlet } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from './AuthProvider'
import { canAccessModule, type ModuleKey } from './useRoles'

function Forbidden() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 gap-4">
      <span className="w-14 h-14 rounded-full bg-destructive/10 text-destructive flex items-center justify-center">
        <ShieldAlert className="w-7 h-7" />
      </span>
      <div>
        <h2 className="text-lg font-bold text-foreground">Access restricted</h2>
        <p className="text-sm text-muted-foreground mt-1 max-w-sm">
          You don&apos;t have a role that grants access to this area. Contact an
          administrator if you believe this is a mistake.
        </p>
      </div>
      <Button asChild variant="outline" size="sm">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  )
}

/**
 * Per-module route enforcement. Renders the matched routes only when the signed-in
 * user's roles include access to `module` (same map nav filtering uses).
 */
export default function RoleGuard({ module }: { module: ModuleKey }) {
  const { user } = useAuth()
  if (!canAccessModule(user?.roles ?? [], module)) return <Forbidden />
  return <Outlet />
}
